import { render } from "./AboutProjectView.vue?vue&type=template&id=d12d9340"
import script from "./AboutProjectView.vue?vue&type=script&lang=js"
export * from "./AboutProjectView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__